import React, { Component } from 'react'
import {
    Container, Row, Col, Button
} from 'reactstrap'
import ProductItemAdmin from '../../itemProductAdmin'
import FormProduct from '../formProduct'
import ProductObj from '../../../../utils/producto'
import './editProd.css'
const prod = new ProductObj()

export default class EditProduct extends Component {
    constructor(props) {
        super(props)

        this.state = {
            producto: {},
            ImgProgress: 0,
            errorMessage: ''
        }
        this.editarProducto = this.editarProducto.bind(this)
        this.guardarCambios = this.guardarCambios.bind(this)
        this.guardarImagen = this.guardarImagen.bind(this)
        this.actualizarImgProgress = this.actualizarImgProgress.bind(this)
        this.getImgUrl = this.getImgUrl.bind(this)
    }

    editarProducto(producto) {
        this.setState({
            producto
        })
    }

    guardarCambios(e) {
        const _this = this
        e.preventDefault()
        prod.guardar(this.state.producto)
            .then(_this.props.history.goBack)
            .catch(errorMessage => _this.setState({ errorMessage }))
    }

    guardarImagen(e) {
        const file = e.target.files[0]
        const reg = /(.*?)\.(jpg|bmp|jpeg|png)$/
        console.log(file)
        if (!file.name.match(reg)) {
            alert("Archivo no válido")
            return false
        }
        const descripcion = `${Date.now()}.${file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)}`
        prod.subirImagenProducto(file, descripcion, this.actualizarImgProgress, this.getImgUrl)
    }

    actualizarImgProgress(ImgProgress) {
        this.setState({
            ImgProgress
        })
    }

    getImgUrl(Img) {
        this.setState({
            producto: {
                ...this.state.producto,
                Img
            },
            ImgProgress: 0
        })
    }

    leerProducto(id) {
        const _this = this
        prod.leerProducto(id).then(producto => {
            // console.log('leerProducto: ', p)
            _this.setState({
                producto:{
                    ...producto,
                    id
                },
                loading: false
            })
        })
    }

    componentWillMount(){
        let product = null
        if (this.props.match) {
            product = this.props.match.params.id
            this.setState({
                loading: true
            })
            if (product)
                return this.leerProducto(product)
        }else{
            this.setState({
                producto: this.props.producto
            })
        }
    }

    render() {
        // console.log('state: ', this.state.producto)
        window.scrollTo(0, 0)
        return (
            <Container className="containerAdmin">
                <Button onClick={this.props.history.goBack} className="btn-rojo">
                    Atrás
                </Button>
                <Row className="rowEdicion">
                    <Col md={6}>
                        <FormProduct producto={this.state.producto} editarProducto={this.editarProducto} guardarCambios={this.guardarCambios} guardarImagen={this.guardarImagen} ImgProgress={this.state.ImgProgress} />
                    </Col>
                    <Col md={6}>
                        <ProductItemAdmin
                            product={this.state.producto}
                        />
                    </Col>
                </Row>

            </Container>
        )
    }


}